import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import "./CancellationPolicy.css";

const CancellationPolicy: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // קביעת כיוון הטקסט לפי השפה
  const direction = i18n.language === "he" ? "rtl" : "ltr";

  // גלילה אוטומטית לתחילת הדף כשמגיעים אליו
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div
      className="cancellation-policy-page"
      dir={direction}
      data-language={i18n.language}
      lang={i18n.language === "he" ? "he" : "ru"}
    >
      <div className="cancellation-policy-container">
        <h1 className="cancellation-policy-title">
          {t("cancellationPolicyTitle")}
        </h1>

        <div className="cancellation-policy-content">
          <section className="cancellation-section">
            <h2>{t("cancellationPolicyIntro")}</h2>
            <p>{t("cancellationPolicyIntroText")}</p>
          </section>

          <section className="cancellation-section">
            <h2>{t("cancellationPolicyRegistrationTitle")}</h2>
            <p>{t("cancellationPolicyRegistrationText")}</p>
          </section>

          <section className="cancellation-section">
            <h2>{t("cancellationPolicy72HoursTitle")}</h2>
            <p>{t("cancellationPolicy72HoursText")}</p>
          </section>

          <section className="cancellation-section">
            <h2>{t("cancellationPolicy24to72HoursTitle")}</h2>
            <p>{t("cancellationPolicy24to72HoursText")}</p>
          </section>

          <section className="cancellation-section">
            <h2>{t("cancellationPolicyLessThan24HoursTitle")}</h2>
            <p>{t("cancellationPolicyLessThan24HoursText")}</p>
          </section>
        </div>

        <div className="custom-button">
          <button onClick={handleGoBack} className="custom-button">
            {t("backToPreviousPage")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;

